module.exports = __webpack_public_path__ + "img/ewallet2.5001048c.png";